import * as ApiUtils from "ApiUtils";

export async function log(event: Record<string, string | undefined>): Promise<void> {
  try {
    await ApiUtils.post("/api/LogEvent", {}, { subtraceTags: event });
  } catch {}
}
